module.exports = __webpack_public_path__ + "static/media/champagne-glasses.06b1ef85.svg";